<app-tournament-header [hidden]="false" [showExportPdf]="partner?.toLowerCase() === 'tmx'" #header></app-tournament-header>

<ion-content>
    <div class="filters-container">
        <!-- Dropdown for Events -->
        <ion-item class="item-selector" *ngIf="events?.length > 0">
            <ion-select interface="popover" [(ngModel)]="eventId" (ionChange)="onEventChange($event)">
                <ion-select-option *ngFor="let event of events" [value]="event.eventId">
                    {{ event.eventName }}
                </ion-select-option>
            </ion-select>
        </ion-item>

        <!-- Dropdown for Draws -->
        <ion-item class="item-selector" *ngIf="drawList?.length > 1">
            <ion-select interface="popover" [(ngModel)]="selectedDrawId" (ionChange)="onDrawChange($event)">
                <ion-select-option *ngFor="let d of drawList" [value]="d.drawId">
                    {{ d.drawName || d.structureName || 'Untitled Draw' }}
                </ion-select-option>
            </ion-select>
        </ion-item>

        <!-- Dropdown for Structures -->
        <ion-item class="item-selector" *ngIf="draws?.length > 0">
            <ion-select interface="popover" [(ngModel)]="drawType" (ionChange)="onDrawEventChange($event)">
                <ion-select-option *ngFor="let draw of draws" [value]="draw">
                    {{ draw }}
                </ion-select-option>
            </ion-select>
        </ion-item>
    </div>

    <div #drawContainer class="draw-container"></div>
    @if (skeletonText) {
        <ng-container *ngTemplateOutlet="skeletonTemplate"></ng-container>
    } 

</ion-content>


<ng-template #skeletonTemplate>
    <div class="ion-padding content-width">
        <div *ngFor="let i of [].constructor(3)">
            <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
            <ion-row>
                <ion-col size="10">
                    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                </ion-col>
                <ion-col size="2">
                    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="10">
                    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                </ion-col>
                <ion-col size="2">
                    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                </ion-col>
            </ion-row>
            <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
            <div style="height: 25px"></div>
        </div>
    </div>
</ng-template>